import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter, NgZone, Injectable } from '@angular/core';
import { IonContent } from '@ionic/angular';  // renamed from Content

import { GlobalService } from 'src/app/services/global/global.service';

// import { Events } from '@ionic/angular';  // deprecated in Ionic 5
import { Events } from 'src/app/services/events/events.service';  // workaround for events

@Component({
  selector: 'mysortheader',
  templateUrl: './mysortheader.component.html',
  styleUrls: ['./mysortheader.component.scss'],
})
export class MysortheaderComponent implements OnInit, OnDestroy  {

  @ViewChild(IonContent) content: IonContent;   
  // https://toddmotto.com/component-events-event-emitter-output-angular-2
  @Input() pageName:string; //@Input('pageName') pageName;
  
  consoleLog:boolean = false;

  public activeSortIndex:number = 0;
  public propMaxIndex:number = 0;
  public items:any;
  public mySortHeaders:MySortHeaders = new MySortHeaders();

  public isPageReady:boolean = false;

  constructor(
      public globalProvider: GlobalService
    , public events: Events
    , public zone: NgZone 
    // public navCtrl: NavController, public navParams: NavParams
  ) 
  {
    this.consoleLog = this.globalProvider.consoleLog_mysortheader;
    if (this.consoleLog) console.log('mysortheader.ctor - LifeCycle');
  }

  // ----------------------------------------------------
  // -------- COMPONENT LIFE-CYCLE EVENTS  --------------
  // ----------------------------------------------------
  ngOnInit() //  ngAfterViewInit()
  {
    if (this.consoleLog) console.log('mysortheader.ngOnInit - ' + this.pageName + ' - LifeCycle');
  }

  // this IS called -- just before the component is removed
  ngOnDestroy() 
  { 
    if (this.consoleLog) console.log('mysortheader.ngOnDestroy - ' + this.pageName + ' - LifeCycle');
  }

  // ----------------------------------------------------
  // ---- FUNCTIONS THAT CAN BE CALLED FROM PARENT  -----
  // ----------------------------------------------------

  public SetPageReady(isPageReady:boolean)
  {
    this.isPageReady = isPageReady;
  }

  public SetItemsArray(items:any)
  {
    this.items = items;  // ugh, kinda hate passing this in here
  }

  public Initialize(mySortHeaders:MySortHeaders)
  {
    this.mySortHeaders = mySortHeaders;

    if ((!this.mySortHeaders) || (!this.mySortHeaders.column))
    {
      console.warn("mysortheader.Initialize: missing sort header array");
      return;
    }

    this.isPageReady = false;
    this.mySortHeaders.isPageReady = true;
    this.propMaxIndex = this.mySortHeaders.column.length - 1; // .Length;

    // get the active sort index
    this.activeSortIndex = -1;
    for (let i = 0; i <= this.propMaxIndex; i++) 
    {
      if (this.mySortHeaders.column[i].active === true)
      {
        this.activeSortIndex = i;
      }
    }

    // set a default sort index if none was present
    if (this.activeSortIndex === -1)
    {
      this.activeSortIndex = 0;
      this.mySortHeaders.column[0].active = true;
    }
  }

  public PerformSortAfterDataRetrieval(items):any
  {
    // using same sort preferences as before
    this.items = items;
    return this.SortByProperty(this.activeSortIndex);
  }

  btnSortByColumn(activeSortIndex):any
  {
    // reverse the order only if we are on the actively sorted column
    if (activeSortIndex === this.activeSortIndex)
    {
      this.mySortHeaders.column[activeSortIndex].reverse = !this.mySortHeaders.column[activeSortIndex].reverse;
    }
    this.activeSortIndex = activeSortIndex;
    return this.SortByProperty(this.activeSortIndex);
  }

  // ----------------------------------------------------
  // ------ INTENDED TO BE INTERNAL FUNCTIONS ONLY  -----
  // ----------------------------------------------------

  SortByProperty(activeSortIndex):any
  {
    console.log("mysortheader.SortByProperty: [" + activeSortIndex + "] ");
    //console.log("mysortheader.SortByProperty: " + propParent + "." + prop + " ASC:" + ascendingFlag + " sortButton:" + sortButton);
    
    // nothing to sort if there are no records
    if (!this.items)
    {
      this.SetPageReady(false);
      console.log("mysortheader.SortByProperty - NO DATA FOUND: [" + activeSortIndex + "] ");
      //console.warn("mysortheader.SortByProperty - NO DATA FOUND: " + propParent + "." + prop + " ASC:" + ascendingFlag + " sortButton:" + sortButton, this.items);
      return [];
    }

    // set the new active index and its properties -- clear out the other properties
    this.SetPageReady(true);
    this.activeSortIndex = activeSortIndex;

    for (let i = 0; i <= this.propMaxIndex; i++) 
    {
      // set the active index and clear the others
      this.mySortHeaders.column[i].active = (i===this.activeSortIndex)? true : false;
    }

    // now sort by the active colulmn
    return this.sortItems( this.items
                         , this.mySortHeaders.column[this.activeSortIndex].parentProp
                         , this.mySortHeaders.column[this.activeSortIndex].prop
                         , this.mySortHeaders.column[this.activeSortIndex].reverse
                         );
  }

  // somewhat generic sort (limitations for 2D structures and fields that are not "unique enough")
  sortItems(items, propParent, prop, ascendingFlag):any
  {
    return items.sort(function(a,b) 
    {
        let propA,propB;
        if (propParent) 
        {
            propA = a[propParent][prop]; // a['EventInfo']['EventId'];
            propB = b[propParent][prop]; // b['EventInfo']['EventId'];
        }
        else 
        {
            propA = a[prop];
            propB = b[prop];
        }

        if (ascendingFlag === true) 
        {
          return propA - propB;
        } 
        else 
        {
          return propB - propA;
        }
    });
  }

}


@Injectable()
export class MySortHeaders 
{
  isPageReady:boolean = false;

  column: Array<{
      display: string
    , index: number
    , parentProp: string
    , prop: string
    , reverse: boolean
    , active: boolean
    }>;

    consoleLog:boolean = false;
  
    constructor(
    ) {
      if (this.consoleLog) console.log('MySortHeaders.ctor - LifeCycle');

      // create a dummy column to get around initial display issue
      this.column = 
      [ { display: "", index: 0, parentProp:"", prop:"", reverse:false, active:false }
      ];
    }
}
